module.exports = __webpack_public_path__ + "static/media/screen-5.c3f5996c.webp";